import { createContext } from 'react';

export const ROLE_ADMIN = 1
export const RoleContext = createContext();
